import { render, staticRenderFns } from "./KelThuzadComponent.vue?vue&type=template&id=76223255&"
import script from "./KelThuzadComponent.vue?vue&type=script&lang=js&"
export * from "./KelThuzadComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports